<!-- Navigation -->
<treo-vertical-navigation
	class="theme-dark"
	[appearance]="'classic'"
	[mode]="isScreenSmall ? 'over' : 'side'"
	[name]="'mainNavigation'"
	[navigation]="data.navigation.default"
	[opened]="!isScreenSmall">
	<div treoVerticalNavigationContentHeader>
		<!-- Actions -->
		<div class="actions">
			<!-- Logo -->
			<div class="logo">
				<img src="assets/images/logo/logo-on-dark.svg" />
			</div>

			<!-- Spacer -->
			<div class="spacer"></div>

			<!-- Notifications -->
			<notifications [notifications]="data.notifications"></notifications>

			<!-- User -->
			<user [user]="data.user" [showAvatar]="false"></user>
		</div>

		<!-- User -->
		<div class="user">
			<div class="avatar">
				<img *ngIf="data.user.avatar" [src]="data.user.avatar" />
				<mat-icon *ngIf="!data.user.avatar" [svgIcon]="'account_circle'"></mat-icon>
			</div>
			<div class="info">
				<div class="name">{{data.user.name}}</div>
				<div class="email text-secondary">{{data.user.email}}</div>
			</div>
		</div>
	</div>

	<ng-container treoVerticalNavigationFooter>
		<div class="mt-2 flex h-16 flex-0 items-center justify-center border-t px-2">
			<button mat-flat-button class="bg-hover flex w-full items-center gap-2" (click)="baixarApp()">
				<mat-icon class="icon-size-5" [svgIcon]="'huge:Download01Icon'"></mat-icon>
				<span>Baixar APP</span>
			</button>
		</div>
	</ng-container>
</treo-vertical-navigation>

<!-- Wrapper -->
<div class="wrapper">
	<!-- Header -->
	<div class="header">
		<!-- Navigation toggle button -->
		<button class="navigation-toggle-button" mat-icon-button (click)="toggleNavigation('mainNavigation')">
			<mat-icon [svgIcon]="'menu'"></mat-icon>
		</button>

		<!-- Spacer -->
		<div class="spacer"></div>

		<!-- Search -->
		<search [appearance]="'bar'"></search>

		<!-- Shortcuts -->
		<shortcuts [shortcuts]="data.shortcuts"></shortcuts>

		<!-- Messages -->
		<messages [messages]="data.messages"></messages>
	</div>

	<!-- Content -->
	<div class="content">
		<!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
             it won't register the changes on the layout and won't update the view. -->
		<router-outlet *ngIf="true"></router-outlet>
	</div>
</div>
